import { registerFunctionalComponent } from 'js/lib/components/component'
import { autosize } from 'js/lib/autosize'

registerFunctionalComponent('.js-c-form-input--textarea', 'InputTextArea', InputTextArea)

function InputTextArea(component) {
  component.useHandler(() => autosize(component.element))
}
